import { useEffect, useState } from "react";
import { Spinner } from "@/components/ui/spinner";

function LoadingOverlay({ isDone }: { isDone: boolean }) {
  const [fading, setFading] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (isDone) {
      setFading(true);
      const timer = setTimeout(() => setHidden(true), 500);
      return () => clearTimeout(timer);
    }
  }, [isDone]);

  if (hidden) {
    return null;
  }

  return (
    <div
      className={
        "fixed inset-0 z-50 flex items-center justify-center bg-black transition-opacity duration-500 ease-out" +
        (fading ? " pointer-events-none opacity-0" : "")
      }
    >
      <Spinner className="size-8 text-white" />
    </div>
  );
}

export { LoadingOverlay };
